import { ChartComponent } from "./chart.component"

export const ChartContainer = () => {
   return <ChartComponent />
}
